'use client'

import { CollectionContainer } from '@/components/common/collection/collection-container'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import Image from 'next/image'

export const HighlightFabricTech = ({ images }: { images: string[] }) => {
  const isMobile = useIsMobileClient()
  return (
    <CollectionContainer>
      <div className='relative'>
        <Carousel
          opts={{
            align: 'start',
            duration: 50,
            slidesToScroll: 2,
            skipSnaps: true,
          }}
          className='w-full'
        >
          <CarouselContent
            className={cn('will-change-transform', !isMobile && 'ml-0')}
          >
            {images.map((image) => (
              <CarouselItem
                className='basis-1/2 sm:basis-1/3 lg:basis-1/4'
                key={image}
              >
                <picture className='group block overflow-hidden rounded-2xl'>
                  <Image
                    src={ImageHelper.getImageUrl(image, '585_663')}
                    alt={image}
                    width={434}
                    height={580}
                    className='w-full object-cover'
                    loading='lazy'
                    unoptimized
                  />
                </picture>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNavigation />
        </Carousel>
      </div>
    </CollectionContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-left-10'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-right-10'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
